import { BookOpen } from "lucide-react";
import { Panel } from "@/components/common";

const Step = ({ n, title, children }) => (
  <li className="flex gap-4">
    <div className="font-mono text-xs font-bold text-emerald-400">{String(n).padStart(2, "0")}</div>
    <div>
      <div className="text-sm font-semibold text-slate-200">{title}</div>
      <div className="mt-1 text-xs leading-relaxed text-slate-400">{children}</div>
    </div>
  </li>
);

const Code = ({ children }) => <span className="break-all rounded bg-[#0a101d] px-1 font-mono text-emerald-300">{children}</span>;

export default function SetupGuide({ status }) {
  return (
    <Panel title="Google setup checklist" icon={BookOpen} testid="setup-guide-panel" className="h-full">
      <ol className="space-y-5">
        <Step n={1} title="Enable the Google Ads API">
          console.cloud.google.com → pick/create a project → APIs & Services → Library → “Google Ads API” → Enable. The project starts with Test access (test accounts only).
        </Step>
        <Step n={2} title="OAuth consent screen (Google Auth Platform)">
          External, add scope <Code>{status.scope}</Code>. Then <b>Google Auth Platform → Audience → Publish app (set to In production)</b>, otherwise Google disconnects you every 7 days.
        </Step>
        <Step n={3} title="Create an OAuth client">
          Credentials → Create credentials → OAuth client ID → <b>Web application</b>. Under Authorized redirect URIs add exactly:
          <div className="mt-1"><Code>{status.redirect_uri}</Code></div>
          Copy the Client ID → <Code>GOOGLE_ADS_CLIENT_ID</Code> and secret → <Code>GOOGLE_ADS_CLIENT_SECRET</Code>.
        </Step>
        <Step n={4} title="Upgrade the project's access level">
          Open the{" "}
          <a data-testid="access-level-link" href={status.access_level_url} target="_blank" rel="noreferrer" className="text-emerald-300 underline underline-offset-2">Google Ads API Overview page</a>{" "}
          in Cloud Console → expand <b>Upgrade access level</b> → <b>Apply for access</b>. <b>Explorer</b> is granted almost instantly and allows real (production) accounts. <b>Basic</b> requires OAuth brand verification. Access now belongs to the Cloud project that owns the OAuth client.
        </Step>
        <Step n={5} title="Manager customer ID">
          The 10-digit ID at the top of your manager account (123-456-7890) → <Code>GOOGLE_ADS_LOGIN_CUSTOMER_ID</Code>
        </Step>
        <Step n={6} title="Connect">
          Paste the values here (or in backend/.env), then press Connect Google Ads and approve access. A developer token is no longer needed (Google sunset them on 9 Sep 2026).
        </Step>
      </ol>
    </Panel>
  );
}
